import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./richtext.css";

interface Props {
  value: string;
  setValue: any;
  error?: string;
  placeholder?: string;
}

const RichText = ({ value, setValue, error, placeholder = "Type here" }: Props) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
  ];

  return (
    <div className={"react-quill-text-container"}>
      <ReactQuill
        className={error ? "error_text_box" : "text_box"}
        theme="snow"
        value={value}
        onChange={setValue}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
};

export default RichText;
